<template>
  <div>
    <el-popover
      ref="popover"
      placement="right-start"
      width="330"
      trigger="hover">
      <image-component :image="img" :width='300'></image-component>
    </el-popover>
    <image-component :image="img" v-popover:popover :width="60"></image-component>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: Object,
      default: {}
    },
  }
}
</script>
